class Animation23 {
  constructor() {
    this.headerAnimation23 = document.querySelector('.ns-header-23');
    this.quarter = document.querySelector('.ns-header-23__quarter-animation--after');

    if(this.headerAnimation23 && this.quarter){
      this.bindAnimation();
    }
  }

  bindAnimation(){
    this.headerAnimation23.classList.add('start');

    let count = 370;
    let changeAmount = 1.9;
    let targetAmount = -10;

    if(this.headerAnimation23.classList.contains('ns-option__quarter--1')) {
      targetAmount = 270;
    } else if(this.headerAnimation23.classList.contains('ns-option__quarter--2')) {
      targetAmount = 180;
    } else if(this.headerAnimation23.classList.contains('ns-option__quarter--3')) {
      targetAmount = 90;
    }

    setTimeout(() => {
      let inter = setInterval(() => {
        if(count <= targetAmount) {
          this.quarter.style.maskImage = "conic-gradient(#fff 0deg,#fff calc(" + targetAmount + "deg),transparent calc(" + targetAmount + "deg),transparent 360deg),conic-gradient(transparent 360deg,#fff 360deg)";
          clearInterval(inter);
        } else {
          this.quarter.style.maskImage = "conic-gradient(#fff 0deg,#fff calc(" + count + "deg),transparent calc(" + count + "deg),transparent 360deg),conic-gradient(transparent 360deg,#fff 360deg)";
          changeAmount *= .997;
          count-= changeAmount;
        }
      },10);
    },1000);
  }
} export default Animation23;
